import { AgentEndpoints, RequestMethods, useRequest } from '@shared/index';
import type { CommonResponse, RequestDeps } from '@shared/types';

import type { SrgAccessRequestParams } from './srgAccess.types';

export const useSrgAccess = (
  request: SrgAccessRequestParams,
  deps: RequestDeps
) => {
  const { res, isLoading, refetch, error, status, isFetching } = useRequest<
    SrgAccessRequestParams,
    CommonResponse,
    CommonResponse
  >({
    params: {
      key: 'srgAccess',
      method: RequestMethods.PUT,
      url: AgentEndpoints.AGENT_SRG,
      request,
      fetchManual: true,
      deps,
    },
  });

  return {
    res,
    error,
    isLoading,
    refetch,
    status,
    isFetching,
  };
};
